export class FilterDto {
  filter: string = '';
  skip: number = 0;
  top: number = 12;
}
